/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Feat_Teams_DescInputs */

const en_upgrade_feat_teams_desc = /** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage staff, agents, and managers with ease.`)
};

const es_upgrade_feat_teams_desc = /** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona personal, agentes y gerentes con facilidad.`)
};

const fr_upgrade_feat_teams_desc = /** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez le personnel, les agents et les responsables en toute simplicité.`)
};

const de_upgrade_feat_teams_desc = /** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte Personal, Agenten und Manager mühelos.`)
};

const id_upgrade_feat_teams_desc = /** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola staf, agen, dan manajer dengan mudah.`)
};

/** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */
const ja_upgrade_feat_teams_desc = en_upgrade_feat_teams_desc;

/** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */
const zh_upgrade_feat_teams_desc = en_upgrade_feat_teams_desc;

/** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */
const ar_upgrade_feat_teams_desc = en_upgrade_feat_teams_desc;

/** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */
const it_upgrade_feat_teams_desc = en_upgrade_feat_teams_desc;

/** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */
const ru_upgrade_feat_teams_desc = en_upgrade_feat_teams_desc;

/** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */
const pt_upgrade_feat_teams_desc = en_upgrade_feat_teams_desc;

/** @type {(inputs: Upgrade_Feat_Teams_DescInputs) => LocalizedString} */
const ko_upgrade_feat_teams_desc = en_upgrade_feat_teams_desc;

/**
* | output |
* | --- |
* | "Manage staff, agents, and managers with ease." |
*
* @param {Upgrade_Feat_Teams_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_feat_teams_desc = /** @type {((inputs?: Upgrade_Feat_Teams_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Feat_Teams_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_feat_teams_desc(inputs)
	if (locale === "es") return es_upgrade_feat_teams_desc(inputs)
	if (locale === "fr") return fr_upgrade_feat_teams_desc(inputs)
	if (locale === "de") return de_upgrade_feat_teams_desc(inputs)
	if (locale === "ja") return ja_upgrade_feat_teams_desc(inputs)
	if (locale === "zh") return zh_upgrade_feat_teams_desc(inputs)
	if (locale === "ar") return ar_upgrade_feat_teams_desc(inputs)
	if (locale === "id") return id_upgrade_feat_teams_desc(inputs)
	if (locale === "it") return it_upgrade_feat_teams_desc(inputs)
	if (locale === "ru") return ru_upgrade_feat_teams_desc(inputs)
	if (locale === "pt") return pt_upgrade_feat_teams_desc(inputs)
	return ko_upgrade_feat_teams_desc(inputs)
});